import { Navigate, useParams } from "react-router-dom";

// Draft boards used to live at /timetable/:uuid, which put a dynamic segment in
// the same position as every named tab — one new tab called "settings" away from
// silently shadowing a run. The board now has its own static segment, and this
// keeps every bookmark and emailed link from that era working.
//
// Declared LAST among the workspace's children: React Router v6 ranks static
// segments above dynamic ones, so the named tabs always win regardless, but the
// ordering documents the intent.
export default function LegacyBoardRedirect() {
  const { uuid } = useParams();
  return <Navigate to={`/timetable/draft/${uuid}`} replace />;
}
